import React, { Component } from 'react';
import { connect } from 'react-redux';
import { reduxForm, change, Field } from 'redux-form';

import { Login, loginValidation  } from '../../actions/authActions';

import { Button, createTheme, Grid, TextField,ThemeProvider } from '@material-ui/core';

import logo from '../../assets/images/SentricsLogoPng.png'


const validate = (values) => {
    const errors = {};

    if(!values.user){
        errors.user = 'Please type the user';

    }

    if(!values.password){
        errors.password = 'Please type the password';

    }

    return errors;
};

const theme = createTheme({
    palette: {
      primary: {
        main:'#000000'
      },
    }

  });

  const renderTextField = ({
    label,
    input,
    meta: { touched, invalid, error },
    ...custom
  }) => (
    <ThemeProvider theme={theme}>
        <TextField
            label={label}
            placeholder={label}
            error={touched && invalid}
            helperText={touched && error}
            {...input}
            {...custom}
        />
    </ThemeProvider>
    
   
  )
  



class RepairsLogin extends Component {
    constructor(props) {
        super(props);

        this.state = {
            user:'',
            password:'',
            apiError:'',
            isDisabled:true

        };
        
        this.props.dispatch(change('RepairsLoginForm', 'user', ''));
        this.props.dispatch(change('RepairsLoginForm', 'password', ''));
    }

    componentDidMount = async () => {

        if (localStorage.getItem("token") != null) {
            await this.props.loginValidation();
            this.props.history.push("/legacyRepairs");
        }
    }

    CheckBtnDisabled =()=>{
        const updState = {
            isDisabled: this.state.isDisabled
        }
        
        if(this.state.user!=='' && this.state.password!==''){
            updState.isDisabled = false;
        }else{
            updState.isDisabled = true
        }

        this.setState(updState);

    }


    handleChange=(target)=>{
        this.setState({
            ...this.state, 
            [target.name]:target.value
        }, ()=>this.CheckBtnDisabled())
    }
    
    handleSubmit=async(e)=>{
        e.preventDefault();
        this.setState({apiError:''})
        const response = await this.props.Login(this.state.user, this.state.password);

        if(!response.success){
            this.setState({apiError:response.error})
            return;
        }

        this.props.history.push("/legacyRepairs")
        
    }
    
    render() {
        return (
            <>
                <Grid item container xs={12} justifyContent='center' className='login_screen' alignItems='center' style={{height:window.innerHeight}}>

                    <Grid item container xs={12} justifyContent='center'>
                        <Grid item container xs={12} justifyContent='center'>
                            <img 
                                src={logo}
                                width='300px'
                                alt='sentrics_logo'
                            />                
                        </Grid>

                        <Grid item container xs={12} justifyContent='center'>
                            <Grid item container xs={10} md={5} lg={4} className='login_container' justifyContent='center' >
                                <Grid item container alignItems='center' justifyContent='center' style={{paddingBottom:'60px'}} >
                                    <svg fill='#105A88' width='30px' height='30px' viewBox="0 0 576 512">                                   
                                        <path xmlns="http://www.w3.org/2000/svg" d="M507.73 109.1c-2.24-9.03-13.54-12.09-20.12-5.51l-74.36 74.36-67.88-11.31-11.31-67.88 74.36-74.36c6.62-6.62 3.43-17.9-5.66-20.16-47.38-11.74-99.55.91-136.58 37.93-39.64 39.64-50.55 97.1-34.05 147.2L18.74 402.76c-24.99 24.99-24.99 65.51 0 90.5 24.99 24.99 65.51 24.99 90.5 0l213.21-213.21c50.12 16.71 107.47 5.68 147.37-34.22 37.07-37.07 49.7-89.32 37.91-136.73zM64 472c-13.25 0-24-10.75-24-24 0-13.26 10.75-24 24-24s24 10.74 24 24c0 13.25-10.75 24-24 24z"/>
                                    </svg>
                                    <span className='login_subtitle'> Repairs </span>
                                </Grid>
                                <form onSubmit={(e)=>this.handleSubmit(e)}>

                                    <Grid item container xs={12} justifyContent='center' >
                                        <ThemeProvider theme={theme}>

                                            <Field
                                                label='User'
                                                name='user'
                                                fullWidth
                                                style={{marginBottom:'20px'}}
                                                component={renderTextField}
                                                InputLabelProps={{
                                                    style:{fontFamily:'Gotham-Book', fontSize:'20px'}
                                                }}
                                                InputProps={{
                                                    style:{fontFamily:'Gotham-Book', fontSize:'20px'}
                                                }}
                                                onChange={({target})=>this.handleChange(target)}
                                                value={this.state.user}

                                            />

                                            <Field
                                                label='Password'
                                                name='password'
                                                fullWidth
                                                type='password'
                                                component={renderTextField}
                                                InputLabelProps={{
                                                    style:{fontFamily:'Gotham-Book', fontSize:'20px'}
                                                }}
                                                InputProps={{
                                                    style:{fontFamily:'Gotham-Book', fontSize:'20px'}
                                                }}
                                                onChange={({target})=>this.handleChange(target)}
                                                value={this.state.password}

                                            />
                                            {
                                                this.state.apiError &&
                                                <Grid item xs={12} className='errorText'>{this.state.apiError}</Grid>
                                            }

                                        </ThemeProvider>

                                        <Grid item xs={6} lg={3} style={{paddingTop:'60px'}}>
                                            <Button  
                                                className={this.state.isDisabled? 'login_btn login_btn_disabled' :'login_btn' } 
                                                type='submit' 
                                                disabled={this.state.isDisabled? true:false}>
                                                Sign In
                                            </Button>
                                        </Grid>
                                    
                                    </Grid>
                                </form>

                            
                            </Grid>
                        </Grid>

                        <Grid item container xs={12} justifyContent='center'>
                            <Grid item container xs={10} md={5} lg={4} justifyContent='flex-end'>
                                <Grid item  className='forgot_password'>
                                    Forgot Password?
                                </Grid>
                            </Grid>                            
                        </Grid>
                    </Grid>
                </Grid>
            </>
        )
    }
}


function mapStateToProps(state){
    
    return {

    }
};

export default connect(mapStateToProps, {Login, loginValidation})
(reduxForm({
    form: 'RepairsLoginForm',
    validate,
    enableReinitialize: true,
})(RepairsLogin));


